// import { frontendVersion } from "@/environment";

let backendVersion = "";

export default function getVersion(): string {
  // lookup backend version from HTML meta
  if (!backendVersion) {
    backendVersion = document.querySelector("meta[name=version]").getAttribute("content");
  }

  // for now, only use a single version
  return backendVersion;
  // return `${frontendVersion}/${backendVersion}`;
}
